<template>
  <div class="pa-4 remanente-rodado-wrapper">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-3">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col cols="12" class="pa-0">
      <v-card class="modern-report-card elevation-2">
        <!-- Header moderno con gradiente y botón de ayuda (Estilo ReporteCurvaDesgasteNeumatico) -->
        <div class="report-header-banner">
          <div class="d-flex align-center header-main-info">
            <div class="header-icon-box mr-3 flex-shrink-0">
              <v-icon color="white">mdi-car-tire-alert</v-icon>
            </div>
            <div class="header-text-block">
              <div class="font-weight-bold white--text header-company-title">
                Remanente de Banda por Unidad
              </div>
              <div class="header-report-subtitle">
                Niveles de desgaste por posición y unidades para reencauche
              </div>
            </div>
          </div>

          <div
            class="header-help-btn ml-auto flex-shrink-0 d-flex align-center"
          >
            <!-- Chip resumen en cabecera si hay resultados -->
            <v-chip
              v-if="
                mostrarTabla &&
                NivelesRemanenteUnidad &&
                NivelesRemanenteUnidad.length > 0
              "
              small
              class="d-none d-sm-inline-flex mr-2 summary-header-chip"
            >
              <v-icon left x-small color="amber lighten-2">mdi-truck</v-icon>
              Unidades: <strong>{{ NivelesRemanenteUnidad.length }}</strong>
            </v-chip>

            <!-- Botón de ayuda -->
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-1 btn-circle-tooltip"
                  icon
                  dark
                  target="_blank"
                  :href="
                    global && global.helpdesk_url
                      ? global.helpdesk_url + 'reporte-generar-consolidado'
                      : '#'
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="22" color="amber lighten-2"
                    >mdi-help-circle-outline</v-icon
                  >
                </v-btn>
              </template>
              <span>¿Necesitas ayuda?</span>
            </v-tooltip>
          </div>
        </div>

        <!-- Cuerpo del Reporte -->
        <v-card-text class="pa-4 pa-md-5">
          <!-- 1. Card de Filtros de Búsqueda -->
          <v-card
            class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-5"
          >
            <div
              class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon small color="primary" class="mr-2"
                  >mdi-filter-variant</v-icon
                >
                <span
                  class="font-weight-bold text-caption text-uppercase text--primary"
                >
                  Filtros de Búsqueda
                </span>
              </div>
            </div>

            <div class="pa-4 pa-md-5">
              <v-row align="center">
                <!-- Cliente -->
                <!-- <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    label="Cliente"
                    :value="
                      Cliente && Cliente.razon_social
                        ? Cliente.razon_social
                        : ''
                    "
                    readonly
                    prepend-inner-icon="mdi-domain"
                    class="field-custom field-readonly"
                  ></v-text-field>
                </v-col> -->

                <!-- RUC -->
                <!-- <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    label="RUC"
                    :value="Cliente && Cliente.ruc ? Cliente.ruc : ''"
                    readonly
                    prepend-inner-icon="mdi-card-bulleted-outline"
                    class="field-custom field-readonly"
                  ></v-text-field>
                </v-col> -->

                <!-- Fecha Inicial -->
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-text-field
                    ref="inputFechaInicial"
                    outlined
                    dense
                    hide-details="auto"
                    type="date"
                    label="Fecha inicial *"
                    v-model="Item.fecha_inicial"
                    prepend-inner-icon="mdi-calendar-start"
                    class="field-custom date-picker-clickable"
                    required
                    @click.native="abrirPickerFecha('inputFechaInicial')"
                    @click:prepend-inner="abrirPickerFecha('inputFechaInicial')"
                  ></v-text-field>
                </v-col>

                <!-- Fecha Final -->
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-text-field
                    ref="inputFechaFinal"
                    outlined
                    dense
                    hide-details="auto"
                    type="date"
                    label="Fecha final *"
                    v-model="Item.fecha_final"
                    prepend-inner-icon="mdi-calendar-end"
                    class="field-custom date-picker-clickable"
                    required
                    @click.native="abrirPickerFecha('inputFechaFinal')"
                    @click:prepend-inner="abrirPickerFecha('inputFechaFinal')"
                  ></v-text-field>
                </v-col>

                <!-- Placas (Selección Múltiple) -->
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    clearable
                    :items="Vehiculos"
                    item-text="text"
                    item-value="value"
                    label="Placas (opcional)"
                    placeholder="Todas o seleccione placas..."
                    v-model="Item.placas"
                    prepend-inner-icon="mdi-car-multiple"
                    class="field-custom placas-autocomplete"
                    :loading="cargandoVehiculos"
                    :disabled="cargandoVehiculos"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        ripple
                        @mousedown.prevent
                        @click="toggleSeleccionarTodasPlacas"
                      >
                        <v-list-item-action>
                          <v-icon
                            :color="
                              Item.placas && Item.placas.length > 0
                                ? 'primary'
                                : ''
                            "
                          >
                            {{ iconSeleccionarTodas }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">
                            Seleccionar todas las placas
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-1"></v-divider>
                    </template>

                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        v-if="index < 2"
                        small
                        class="my-1 font-weight-medium"
                        close
                        @click:close="removerPlaca(item.value)"
                      >
                        <span>{{ item.value }}</span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption font-weight-bold ml-1"
                      >
                        (+{{ (Item.placas ? Item.placas.length : 0) - 2 }} más)
                      </span>
                    </template>

                    <template v-slot:progress>
                      <v-progress-linear
                        color="primary"
                        indeterminate
                        height="3"
                        rounded
                        class="input-loading-bar"
                      ></v-progress-linear>
                    </template>
                  </v-autocomplete>
                </v-col>

                <!-- Botón Filtrar -->
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  lg="3"
                  class="d-flex align-center"
                >
                  <v-btn
                    @click="validacionCampos()"
                    color="primary"
                    block
                    height="40"
                    class="filter-action-btn font-weight-bold"
                    :disabled="Item.fecha_final == null || loader"
                    :loading="loader"
                  >
                    <v-icon left small>mdi-magnify</v-icon>
                    Filtrar
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card>

          <!-- Estado 1: Cargando datos -->
          <div
            v-if="loader"
            class="chart-loading-state rounded-lg pa-10 d-flex flex-column align-center justify-center text-center my-4"
          >
            <v-progress-circular
              indeterminate
              size="52"
              width="4"
              color="primary"
              class="mb-4"
            ></v-progress-circular>
            <div
              class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1"
            >
              Consultando niveles de remanente...
            </div>
            <div class="text-caption grey--text text--darken-1">
              Procesando matriz por posición y neumáticos para reencauche
            </div>
          </div>

          <!-- Estado 2: Sin consulta inicial -->
          <div
            v-else-if="!mostrarTabla"
            class="chart-empty-state rounded-lg pa-8 pa-md-12 d-flex flex-column align-center justify-center text-center my-4"
          >
            <div class="empty-state-icon-circle mb-4">
              <v-icon size="48" color="primary lighten-1"
                >mdi-calendar-clock-outline</v-icon
              >
            </div>
            <h3 class="text-h6 font-weight-bold grey--text text--darken-3 mb-2">
              Consulte el remanente de banda
            </h3>
            <p class="text-body-2 grey--text text--darken-1 max-width-480 mb-4">
              Seleccione el rango de fechas inicial y final para obtener los
              niveles de remanente por posición, unidades evaluadas y alertas de
              reemplazo.
            </p>
            <v-chip outlined small color="primary" class="font-weight-medium">
              <v-icon left x-small>mdi-filter-variant</v-icon>
              Complete las fechas y presione "Filtrar"
            </v-chip>
          </div>

          <!-- Estado 3: Tabla de Resultados y KPIs -->
          <div v-else-if="mostrarTabla" class="remanente-results-content">
            <!-- KPIs Ejecutivos -->
            <v-row
              dense
              class="mb-4"
              v-if="NivelesRemanenteUnidad && NivelesRemanenteUnidad.length > 0"
            >
              <!-- Total Vehículos -->
              <v-col cols="12" sm="6" md="3">
                <div class="kpi-mini-card">
                  <div class="kpi-icon-wrap kpi-icon--neutral">
                    <v-icon color="grey darken-2">mdi-truck-outline</v-icon>
                  </div>
                  <div>
                    <div class="kpi-label">Vehículos Evaluados</div>
                    <div class="kpi-value">
                      {{ NivelesRemanenteUnidad.length }}
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- Total Neumáticos -->
              <v-col cols="12" sm="6" md="3">
                <div class="kpi-mini-card">
                  <div class="kpi-icon-wrap kpi-icon--neutral">
                    <v-icon color="primary">mdi-tire</v-icon>
                  </div>
                  <div>
                    <div class="kpi-label">Total Neumáticos</div>
                    <div class="kpi-value">
                      {{ Resumen.total_neumaticos || 0 }}
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- Para Reencauchar -->
              <v-col cols="12" sm="6" md="3">
                <div class="kpi-mini-card kpi-card--warning">
                  <div class="kpi-icon-wrap kpi-icon--warning">
                    <v-icon color="amber darken-3"
                      >mdi-alert-circle-outline</v-icon
                    >
                  </div>
                  <div class="flex-grow-1">
                    <div class="d-flex align-center justify-space-between">
                      <span class="kpi-label amber--text text--darken-4"
                        >Para Reencauchar</span
                      >
                    </div>
                    <div class="kpi-value amber--text text--darken-4">
                      {{ Resumen.total_neumaticos_reencauchar || 0 }}
                      ({{
                        calcularPorcentaje(
                          Resumen.total_neumaticos_reencauchar,
                          Resumen.total_neumaticos,
                        )
                      }})
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- Próximos a Reencauchar -->
              <v-col cols="12" sm="6" md="3">
                <div class="kpi-mini-card kpi-card--info">
                  <div class="kpi-icon-wrap kpi-icon--info">
                    <v-icon color="cyan darken-3"
                      >mdi-clock-alert-outline</v-icon
                    >
                  </div>
                  <div class="flex-grow-1">
                    <div class="d-flex align-center justify-space-between">
                      <span class="kpi-label cyan--text text--darken-4"
                        >Próx. a Reencauchar</span
                      >
                    </div>
                    <div class="kpi-value cyan--text text--darken-4">
                      {{ Resumen.neumaticos_proximos_reencauchar || 0 }}
                      ({{
                        calcularPorcentaje(
                          Resumen.neumaticos_proximos_reencauchar,
                          Resumen.total_neumaticos,
                        )
                      }})
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- Barra de Leyenda de Colores -->
            <div
              class="legend-bar px-4 py-2 mb-4 d-flex align-center flex-wrap"
              v-if="NivelesRemanenteUnidad && NivelesRemanenteUnidad.length > 0"
            >
              <span
                class="text-caption font-weight-bold grey--text text--darken-2 mr-3 d-flex align-center"
              >
                <v-icon x-small color="grey darken-2" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                Leyenda de Alertas:
              </span>
              <div class="d-flex align-center mr-4 my-1">
                <span class="legend-badge legend-badge--warning mr-2"></span>
                <span
                  class="text-caption font-weight-bold grey--text text--darken-4"
                >
                  Reencauchar (Remanente ≤ Límite de Retiro)
                </span>
              </div>
              <div class="d-flex align-center mr-4 my-1">
                <span class="legend-badge legend-badge--info mr-2"></span>
                <span
                  class="text-caption font-weight-bold grey--text text--darken-4"
                >
                  Próximo a Reencauchar (Rango Preventivo)
                </span>
              </div>
              <div class="d-flex align-center my-1">
                <span class="legend-badge legend-badge--normal mr-2"></span>
                <span
                  class="text-caption font-weight-bold grey--text text--darken-4"
                >
                  Operativo Normal
                </span>
              </div>
            </div>

            <!-- Card de Tabla Principal -->
            <v-card
              class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-4"
            >
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center py-1">
                  <v-icon small color="primary" class="mr-2"
                    >mdi-table-large</v-icon
                  >
                  <span
                    class="font-weight-bold text-caption text-uppercase text--primary"
                  >
                    Niveles de Remanente por Unidad
                  </span>
                </div>

                <div class="d-flex align-center py-1">
                  <v-chip
                    v-if="NivelesRemanenteUnidad"
                    x-small
                    color="primary lighten-4"
                    class="primary--text font-weight-bold"
                  >
                    {{ NivelesRemanenteUnidad.length }} registros
                  </v-chip>
                </div>
              </div>

              <!-- Indicador de desplazamiento horizontal en celular -->
              <div
                class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-3 pt-2"
              >
                <v-icon x-small color="primary" class="mr-1">
                  mdi-gesture-swipe-horizontal
                </v-icon>
                <span
                  >Desliza horizontalmente para ver todas las posiciones</span
                >
              </div>

              <!-- Contenedor Responsive de Tabla -->
              <div class="table-responsive-wrapper">
                <table
                  class="modern-dashboard-table modern-matrix-table"
                  id="table"
                >
                  <thead>
                    <tr>
                      <th class="text-center cell-freeze" colspan="3">
                        DATOS DE LA UNIDAD
                      </th>
                      <th
                        class="text-center header-positions-group"
                        :colspan="
                          Array.isArray(NivelesRemanenteUnidadPosiciones)
                            ? NivelesRemanenteUnidadPosiciones.length
                            : 0
                        "
                      >
                        POSICIONES (REMANENTE MM)
                      </th>
                      <th
                        class="text-center"
                        rowspan="2"
                        style="min-width: 90px"
                      >
                        TOTAL
                      </th>
                      <th class="text-center header-replace-group" colspan="2">
                        PARA REEMPLAZAR
                      </th>
                    </tr>
                    <tr>
                      <th
                        class="text-center cell-freeze"
                        style="min-width: 140px"
                      >
                        VEHÍCULO
                      </th>
                      <th
                        class="text-center cell-freeze"
                        style="min-width: 110px"
                      >
                        FECHA
                      </th>
                      <th
                        class="text-center cell-freeze"
                        style="min-width: 100px"
                      >
                        PLACA
                      </th>
                      <th
                        v-for="(
                          item, index
                        ) in NivelesRemanenteUnidadPosiciones"
                        :key="'pos-head-' + index"
                        class="text-center subheader-pos"
                        style="min-width: 70px"
                      >
                        POS {{ item }}
                      </th>
                      <th
                        class="text-center subheader-warning"
                        style="min-width: 110px"
                      >
                        REENCAUCHAR
                      </th>
                      <th
                        class="text-center subheader-info"
                        style="min-width: 130px"
                      >
                        PRÓX. A REENCAUCHAR
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in remanentesPaginados"
                      :key="'rem-row-' + index"
                    >
                      <td class="text-center font-weight-medium cell-freeze">
                        <v-chip
                          x-small
                          color="blue-grey lighten-5"
                          class="blue-grey--text text--darken-3 font-weight-bold"
                        >
                          {{ item.tipovehiculo }}
                        </v-chip>
                      </td>
                      <td class="text-center cell-freeze text-caption">
                        {{ item.fecha }}
                      </td>
                      <td
                        class="text-center cell-freeze font-weight-bold primary--text"
                      >
                        {{ item.placa }}
                      </td>

                      <!-- Celdas de Posiciones con Semáforo -->
                      <td
                        v-for="(
                          item2, index2
                        ) in NivelesRemanenteUnidadPosiciones"
                        :key="'val-' + index + '-' + index2"
                        :class="tdPintar(tdValorPosicion(item, item2), item)"
                        class="pos-value-cell"
                      >
                        {{ tdValorPosicion(item, item2) || "-" }}
                      </td>

                      <td class="text-center font-weight-bold">
                        {{ item.total_neumaticos }}
                      </td>
                      <td class="text-center bg-celda-amarilla">
                        {{ item.neumaticos_reencauchar }}
                      </td>
                      <td class="text-center bg-celda-azul">
                        {{ item.neumaticos_proximos_reencauchar }}
                      </td>
                    </tr>

                    <!-- Filas de Totales Generales -->
                    <tr
                      v-if="
                        NivelesRemanenteUnidad &&
                        NivelesRemanenteUnidad.length > 0
                      "
                      class="row-total-highlight"
                    >
                      <td
                        class="text-right font-weight-bold pr-4 cell-freeze"
                        :colspan="
                          3 +
                          (Array.isArray(NivelesRemanenteUnidadPosiciones)
                            ? NivelesRemanenteUnidadPosiciones.length
                            : 0)
                        "
                        rowspan="2"
                      >
                        TOTAL GENERAL:
                      </td>
                      <td
                        class="text-center font-weight-bold indigo--text text--darken-3"
                        rowspan="2"
                      >
                        {{ Resumen.total_neumaticos }}
                      </td>
                      <td
                        class="text-center font-weight-bold bg-celda-amarilla"
                      >
                        {{ Resumen.total_neumaticos_reencauchar }}
                      </td>
                      <td class="text-center font-weight-bold bg-celda-azul">
                        {{ Resumen.neumaticos_proximos_reencauchar }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        NivelesRemanenteUnidad &&
                        NivelesRemanenteUnidad.length > 0
                      "
                      class="row-total-highlight"
                    >
                      <td
                        class="text-center font-weight-bold text-caption bg-celda-amarilla"
                      >
                        {{
                          calcularPorcentaje(
                            Resumen.total_neumaticos_reencauchar,
                            Resumen.total_neumaticos,
                          )
                        }}
                      </td>
                      <td
                        class="text-center font-weight-bold text-caption bg-celda-azul"
                      >
                        {{
                          calcularPorcentaje(
                            Resumen.neumaticos_proximos_reencauchar,
                            Resumen.total_neumaticos,
                          )
                        }}
                      </td>
                    </tr>

                    <!-- Sin registros -->
                    <tr
                      v-if="
                        !NivelesRemanenteUnidad ||
                        NivelesRemanenteUnidad.length === 0
                      "
                    >
                      <td
                        class="text-center py-8 text-caption grey--text"
                        :colspan="
                          6 +
                          (Array.isArray(NivelesRemanenteUnidadPosiciones)
                            ? NivelesRemanenteUnidadPosiciones.length
                            : 0)
                        "
                      >
                        No se encontraron datos de remanentes para los filtros
                        seleccionados.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Paginador similar a v-data-table footer -->
              <div
                v-if="
                  NivelesRemanenteUnidad && NivelesRemanenteUnidad.length > 0
                "
                class="table-pagination-footer d-flex flex-wrap align-center justify-space-between px-4 py-2"
              >
                <div class="d-flex align-center my-1">
                  <span class="text-caption grey--text text--darken-2 mr-2">
                    Filas por página:
                  </span>
                  <div style="width: 75px">
                    <v-select
                      v-model="itemsPorPagina"
                      :items="[10, 15, 25, 50, 100]"
                      dense
                      hide-details
                      outlined
                      class="pagination-select"
                      @change="paginaActual = 1"
                    ></v-select>
                  </div>
                </div>

                <div class="d-flex align-center my-1">
                  <span class="text-caption grey--text text--darken-2 mr-3">
                    {{ textoPaginacion }}
                  </span>
                  <v-btn
                    icon
                    small
                    :disabled="paginaActual <= 1"
                    @click="paginaActual = 1"
                    title="Primera página"
                  >
                    <v-icon small>mdi-page-first</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    :disabled="paginaActual <= 1"
                    @click="paginaActual--"
                    title="Página anterior"
                  >
                    <v-icon small>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    :disabled="paginaActual >= totalPaginas"
                    @click="paginaActual++"
                    title="Página siguiente"
                  >
                    <v-icon small>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    :disabled="paginaActual >= totalPaginas"
                    @click="paginaActual = totalPaginas"
                    title="Última página"
                  >
                    <v-icon small>mdi-page-last</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import { axios2 as axios } from "@/interceptor/useApi";
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";
import global from "@/global";

export default {
  data() {
    return {
      global,
      NivelesRemanenteUnidadPosiciones: [],
      AplicacionesRemanenteUnidad: [],
      NivelesRemanenteUnidad: [],
      Resumen: {},
      Item: {
        fecha_inicial: null,
        fecha_final: null,
        placas: [],
        placa: null,
      },
      Vehiculos: [],
      cargandoVehiculos: false,
      loader: false,
      mostrarTabla: false,
      paginaActual: 1,
      itemsPorPagina: 15,
    };
  },
  computed: {
    ...mapState("cliente", ["Cliente"]),

    todasPlacasSeleccionadas() {
      return (
        this.Vehiculos.length > 0 &&
        Array.isArray(this.Item.placas) &&
        this.Item.placas.length === this.Vehiculos.length
      );
    },

    algunasPlacasSeleccionadas() {
      return (
        Array.isArray(this.Item.placas) &&
        this.Item.placas.length > 0 &&
        !this.todasPlacasSeleccionadas
      );
    },

    iconSeleccionarTodas() {
      if (this.todasPlacasSeleccionadas) return "mdi-close-box";
      if (this.algunasPlacasSeleccionadas) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    totalPaginas() {
      if (
        !this.NivelesRemanenteUnidad ||
        this.NivelesRemanenteUnidad.length === 0
      ) {
        return 1;
      }
      return Math.ceil(
        this.NivelesRemanenteUnidad.length / this.itemsPorPagina,
      );
    },

    remanentesPaginados() {
      if (!this.NivelesRemanenteUnidad) return [];
      const inicio = (this.paginaActual - 1) * this.itemsPorPagina;
      return this.NivelesRemanenteUnidad.slice(
        inicio,
        inicio + this.itemsPorPagina,
      );
    },

    textoPaginacion() {
      if (
        !this.NivelesRemanenteUnidad ||
        this.NivelesRemanenteUnidad.length === 0
      ) {
        return "0-0 de 0";
      }
      const total = this.NivelesRemanenteUnidad.length;
      const inicio = (this.paginaActual - 1) * this.itemsPorPagina + 1;
      const fin = Math.min(this.paginaActual * this.itemsPorPagina, total);
      return `${inicio}-${fin} de ${total}`;
    },
  },
  methods: {
    ...mapActions("cliente", ["ObtenerDatosCliente"]),

    messageErrorAlert: function () {
      Swal.fire({
        title: "Upps, algo paso!",
        text: "Servidor desconectado, por favor actualice la ventana!",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Actualizar",
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `,
        },
        backdrop: `
          rgba(255,0,0,0.1)
          left top
          no-repeat
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          location.reload();
        }
      });
    },

    abrirPickerFecha: function (refName) {
      const comp = this.$refs[refName];
      const input =
        comp && comp.$el ? comp.$el.querySelector('input[type="date"]') : null;
      if (input && typeof input.showPicker === "function") {
        try {
          input.showPicker();
        } catch (e) {
          // Ignorar si el picker ya está desplegado por el navegador
        }
      }
    },

    validacionCampos: function () {
      if (this.Item.fecha_inicial > this.Item.fecha_final) {
        this.mostrarTabla = false;
        this.$alertify.error(
          "Por favor, ingresar una fecha igual o mayor a la primera fecha seleccionada",
        );
      } else {
        this.loader = true;
        this.cargarRemanentesFiltro();
      }
    },

    cargarRemanentesFiltro: async function () {
      try {
        const url = "reporte/nivelesremanenteunidad";
        const placasArray = Array.isArray(this.Item.placas)
          ? this.Item.placas.filter((p) => p && p.toString().trim() !== "")
          : this.Item.placa
          ? [this.Item.placa]
          : [];

        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          placas: placasArray,
          placa: placasArray,
          fecha_inicial: this.Item.fecha_inicial,
          fecha_final: this.Item.fecha_final,
        };
        await axios
          .post(url, data)
          .then((response) => {
            this.NivelesRemanenteUnidadPosiciones =
              response.data.success.posiciones || [];
            this.NivelesRemanenteUnidad = response.data.success.datos || [];
            this.AplicacionesRemanenteUnidad =
              response.data.success.aplicaciones || [];
            this.Resumen = response.data.success.resumen || {};
            this.paginaActual = 1;
            this.loader = false;
            this.mostrarTabla = true;
          })
          .catch((error) => {
            this.errorMessage = error.response ? error.response.data : error;
            console.error("error!", error);
            this.messageErrorAlert();
          });
      } catch (error) {
        console.log(error);
        this.messageErrorAlert();
      }
    },

    tdValorPosicion: function (itemOrIndex, item2) {
      const row =
        typeof itemOrIndex === "object" && itemOrIndex !== null
          ? itemOrIndex
          : this.NivelesRemanenteUnidad &&
            this.NivelesRemanenteUnidad[itemOrIndex];
      if (!row) {
        return "-";
      }
      const val = row["nsk_minimo_" + item2];
      if (val === null || val === undefined || val === "" || val === "-") {
        return "-";
      }
      return val;
    },

    tdPintar: function (nsk_minimo, param) {
      let rem_proximo_aru = parseFloat(param["rem_proximo"]) ?? 0;
      let rem_reencauche_aru = parseFloat(param["rem_reencauche"]) ?? 0;

      let pintar = "";
      if (nsk_minimo != "-" && nsk_minimo) {
        if (nsk_minimo <= rem_proximo_aru && nsk_minimo > rem_reencauche_aru) {
          pintar = "border texto-cen bg-celda-azul pa-1";
        } else if (nsk_minimo <= rem_reencauche_aru) {
          pintar = "border texto-cen bg-celda-amarilla pa-1";
        } else {
          pintar = "border texto-cen pa-1";
        }
      } else {
        pintar = "border texto-cen pa-1";
      }
      return pintar;
    },

    calcularPorcentaje: function (cantidad, total) {
      total = total == 0 || total == undefined || total == null ? 1 : total;
      let valor = ((cantidad / total) * 100).toFixed(2);
      return valor + "%";
    },

    cargarVehiculos: async function () {
      this.cargandoVehiculos = true;
      const data = {
        id_cliente: localStorage.getItem("idcliente"),
      };
      try {
        const url = "vehiculos/showminified";
        await axios
          .post(url, data)
          .then((response) => {
            const seen = new Set();
            const list =
              response.data && response.data.data ? response.data.data : [];
            const vehiculos = [];
            list.forEach((el) => {
              if (el && el.placa && !seen.has(el.placa)) {
                seen.add(el.placa);
                vehiculos.push({
                  value: el.placa,
                  text: el.codigo ? `${el.placa} / ${el.codigo}` : el.placa,
                  placa: el.placa,
                  codigo: el.codigo,
                });
              }
            });
            this.Vehiculos = vehiculos;
          })
          .catch((error) => {
            console.error("Error al cargar vehículos:", error);
          })
          .finally(() => {
            this.cargandoVehiculos = false;
          });
      } catch (error) {
        console.error("Error en cargarVehiculos:", error);
        this.cargandoVehiculos = false;
      }
    },

    toggleSeleccionarTodasPlacas: function () {
      this.$nextTick(() => {
        if (this.todasPlacasSeleccionadas) {
          this.Item.placas = [];
        } else {
          this.Item.placas = this.Vehiculos.map((v) => v.value);
        }
      });
    },

    removerPlaca: function (placa) {
      if (Array.isArray(this.Item.placas)) {
        const idx = this.Item.placas.indexOf(placa);
        if (idx >= 0) {
          this.Item.placas.splice(idx, 1);
        }
      }
    },
  },
  mounted() {
    this.ObtenerDatosCliente();
    this.cargarVehiculos();
  },
};
</script>

<style scoped>
/* =========================================================
   UI/UX STYLES - REPORTE REMANENTE DE BANDA POR UNIDAD
   Basado en ReporteCurvaDesgasteNeumatico.vue y ReporteConsolidado.vue
   ========================================================= */

.remanente-rodado-wrapper {
  background-color: #f8fafc;
  min-height: 100%;
}

/* Botón Volver */
.back-btn {
  font-weight: 700;
  letter-spacing: 0.3px;
  border-radius: 8px;
  text-transform: none;
  transition: all 0.2s ease;
}

.back-btn:hover {
  transform: translateX(-2px);
}

/* Card y Header Modernos */
.modern-report-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  background: #ffffff !important;
}

.report-header-banner {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.header-main-info {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-help-btn {
  flex: 0 0 auto;
  flex-shrink: 0;
  white-space: nowrap;
}

.header-icon-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.header-company-title {
  font-size: 1.05rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-report-subtitle {
  color: #94a3b8;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-header-chip {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  color: #ffffff !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
  transform: scale(1.06);
}

/* Cards internas Dashboard */
.dashboard-chart-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.25s ease, border-color 0.2s ease;
}

.dashboard-chart-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05) !important;
}

.chart-subtitle-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.815rem;
  line-height: 1.35;
  min-height: 42px;
}

/* KPI Cards */
.kpi-mini-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
  height: 100%;
}

.kpi-mini-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.kpi-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kpi-icon--neutral {
  background: #f1f5f9;
}

.kpi-card--warning {
  border-color: #fef08a !important;
  background: linear-gradient(180deg, #ffffff 0%, #fefce8 100%);
}

.kpi-icon--warning {
  background: #fef08a;
}

.kpi-card--info {
  border-color: #bae6fd !important;
  background: linear-gradient(180deg, #ffffff 0%, #f0f9ff 100%);
}

.kpi-icon--info {
  background: #bae6fd;
}

.kpi-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #64748b;
  line-height: 1.2;
}

.kpi-value {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
  margin-top: 2px;
}

/* Barra de Leyenda */
.legend-bar {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.legend-badge {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  display: inline-block;
  vertical-align: middle;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.legend-badge--warning {
  background-color: #fde047;
  border: 1.5px solid #ca8a04;
}

.legend-badge--info {
  background-color: #7dd3fc;
  border: 1.5px solid #0284c7;
}

.legend-badge--normal {
  background-color: #e2e8f0;
  border: 1.5px solid #94a3b8;
}

/* Estados Vacío y Carga */
.chart-empty-state {
  min-height: 340px;
  background: #f8fafc;
  border: 1.5px dashed #cbd5e1;
}

.empty-state-icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-loading-state {
  min-height: 340px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.max-width-480 {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}

/* Tablas Modernas */
.table-responsive-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.modern-dashboard-table {
  width: 100%;
  min-width: 1050px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12.5px;
}

.modern-dashboard-table thead th {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  color: #334155;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 10px 14px;
  border-bottom: 2px solid #cbd5e1;
  border-right: 1px solid #e2e8f0;
  white-space: nowrap;
}

.modern-dashboard-table tbody tr {
  transition: background-color 0.15s ease;
  border-bottom: 1px solid #e2e8f0;
}

.modern-dashboard-table tbody tr:hover {
  background-color: #f8fafc;
}

.modern-dashboard-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #edf2f7;
  border-right: 1px solid #edf2f7;
  color: #1e293b;
  vertical-align: middle;
}

.header-positions-group {
  background: linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%) !important;
  color: #1e40af !important;
  font-weight: 800 !important;
}

.header-replace-group {
  background: linear-gradient(180deg, #fef08a 0%, #fde047 100%) !important;
  color: #713f12 !important;
  font-weight: 800 !important;
}

.subheader-pos {
  background: #f8fafc !important;
  color: #475569 !important;
  font-size: 11px !important;
}

.subheader-warning {
  background: #fde047 !important;
  color: #713f12 !important;
  font-size: 11px !important;
  font-weight: 800 !important;
}

.subheader-info {
  background: #7dd3fc !important;
  color: #0c4a6e !important;
  font-size: 11px !important;
  font-weight: 800 !important;
}

.cell-freeze {
  background-color: #f8fafc;
  font-weight: 600;
}

.pos-value-cell {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  font-size: 12.5px;
  text-align: center;
}

/* Colores de Celdas (Tonos con mayor opacidad y contraste para evitar aspecto blanquecino) */
.bg-celda-amarilla {
  background-color: #fde047 !important;
  color: #713f12 !important;
  font-weight: 800 !important;
}

.bg-celda-azul {
  background-color: #7dd3fc !important;
  color: #0c4a6e !important;
  font-weight: 800 !important;
}

.row-total-highlight {
  background-color: #f8fafc !important;
  border-top: 2px solid #cbd5e1 !important;
}

/* Campos de Formulario */
.field-custom ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.field-custom ::v-deep .v-input__slot:hover {
  background: #ffffff !important;
}

.field-custom ::v-deep.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

.field-readonly ::v-deep .v-input__slot {
  background: #f1f5f9 !important;
  cursor: not-allowed;
}

.filter-action-btn {
  border-radius: 8px !important;
  letter-spacing: 0.3px;
  text-transform: none;
}

.texto-cen {
  text-align: center;
}

.texto-izq {
  text-align: left;
}

/* Date Picker clickeable en cualquier sección */
.date-picker-clickable,
.date-picker-clickable ::v-deep .v-input__slot,
.date-picker-clickable ::v-deep input[type="date"],
.date-picker-clickable ::v-deep .v-input__prepend-inner {
  cursor: pointer !important;
}

.date-picker-clickable
  ::v-deep
  input[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
}

.placas-autocomplete ::v-deep .v-select__selections {
  min-height: 28px;
  align-items: center;
}

/* El slot del input debe ser el contexto de posicionamiento para la barra */
.placas-autocomplete ::v-deep .v-input__slot,
.field-custom ::v-deep .v-input__slot {
  position: relative !important;
  overflow: hidden !important;
}

/* Barra de loading pegada al borde inferior interior del input */
.placas-autocomplete ::v-deep .v-progress-linear,
.field-custom ::v-deep .v-progress-linear,
.input-loading-bar {
  position: absolute !important;
  bottom: 0 !important;
  top: auto !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  border-radius: 0 !important;
  overflow: hidden !important;
  margin: 0 !important;
}

/* Paginador de tabla */
.table-pagination-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #fafafa;
  font-size: 11px;
}

.pagination-select ::v-deep .v-input__slot {
  min-height: 28px !important;
  padding: 0 6px !important;
  font-size: 11px !important;
  background: #ffffff !important;
}

.pagination-select ::v-deep .v-select__selection {
  font-size: 11px !important;
}

.pagination-select ::v-deep .v-input__append-inner {
  margin-top: 3px !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .report-header-banner {
    padding: 12px 14px;
    gap: 8px;
  }

  .header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }

  .header-company-title {
    font-size: 0.85rem !important;
  }

  .header-report-subtitle {
    font-size: 0.68rem !important;
  }

  .modern-dashboard-table {
    min-width: 950px;
    font-size: 10.5px;
  }

  .modern-dashboard-table thead th {
    padding: 6px 4px;
    font-size: 9.5px;
  }

  .modern-dashboard-table tbody td {
    padding: 6px 4px;
    font-size: 10px;
  }

  .pos-value-cell {
    font-size: 10.5px;
  }

  .table-pagination-footer {
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 8px 6px;
  }
}
</style>
